import styled from "@emotion/styled";
import { useState } from "react";
import { Box } from "@mui/material";
import { logOut } from "../../api/client";
import { LogOutIcon } from "../../assets/icons/icons";
import { NongCallLogo3 } from "../../assets/images/images";
import userStorage from "../../utils/userStorage";
import UserDetailModal from "../../components/userDetailModal/userDetailModal";
import UserModifyModal from "../../components/userModifyModal/userModifyModal";
import { User, MemberDetail } from "../../types/types";
import { useNavigate } from "react-router-dom";
import theme from "../../theme";
import { HeaderUser } from "../../components/headerUser";
import { useSystemSetting } from "../../hooks/useSystemSetting";

const Header: React.FC<{}> = () => {
  const user = userStorage.get();
  const [open, setOpen] = useState(false);
  const [detailData, setDetailData] = useState<MemberDetail>();
  const [openModify, setOpenModify] = useState(false);
  const [idx, setIdx] = useState(0);
  const navigate = useNavigate();
  const systemSetting = useSystemSetting();

  const userModalonPressNo = () => {
    setOpen(false);
  };
  const onClickModify = () => {
    setOpen(false);
    setOpenModify(true);
  };

  const onClickDetail = (el: User) => {
    setIdx(el.idx);
    setOpen(true);
  };

  const onPressNoModify = () => {
    setOpenModify(false);
  };

  const handleClick = () => {
    if (user) {
      onClickDetail(user);
    }
    return;
  };

  const hadleLogout = () => {
    const result = window.confirm(`로그아웃하시겠습니까 ?`);
    if (result) {
      logOut();
      navigate(`/login`, { replace: true });
    } else if (!result) {
      return;
    }
  };

  // console.log(user && user);

  return (
    <Box
      sx={{
        pl: { xs: "10px", sm: "30px" },
        pt: { xs: "10px", sm: "20px" },
        pr: { xs: "10px", sm: "30px" },
        pb: { xs: "10px", sm: "20px" },
        borderBottom: `3px solid ${theme.color.neutral_200}`,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <NongCallLogo3 width={92} height={36} />
      <OptionWrapper>
        <HeaderUser
          onNext={handleClick}
          systemSetting={systemSetting("admin")}
        />

        <IconWrapper2 onClick={hadleLogout}>
          <LogOutIcon />
          <HeaderFont>로그아웃</HeaderFont>
        </IconWrapper2>
      </OptionWrapper>

      {/* 마이페이지 모달 */}
      {open && (
        <UserDetailModal
          idx={idx}
          open={open}
          onPressNo={userModalonPressNo}
          setDetailData={setDetailData}
          onClickModify={onClickModify}
          isMyPage={true}
          systemSetting={systemSetting("admin")}
        />
      )}
      {/* 정보수정하기 모달 */}
      {openModify && (
        <UserModifyModal
          open={openModify}
          data={detailData}
          idx={idx}
          onPressNo={onPressNoModify}
          isMyPage={true}
          systemSetting={systemSetting("admin")}
        />
      )}
    </Box>
  );
};

const OptionWrapper = styled.div`
  display: flex;
  gap: 42px;
  align-items: center;
  @media (max-width: ${theme.screen.sm}px) {
    gap: 20px;
  }
`;

const IconWrapper2 = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 7px;
  &:hover span {
    color: ${theme.statusColor.MAIN};
  }
  &:hover svg path {
    fill: ${theme.statusColor.MAIN};
  }
`;

const HeaderFont = styled.span`
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  color: ${theme.color.neutral_400};
  cursor: pointer;
`;
export default Header;
